<template>
	<div class="user-information">
		<section>
			<info-card>
				<div
					class="avatar bg-cover"
					:style="`background-image: url('${user.image || require('@/assets/img/avatar-default.png')}')`"
				>
					<span class="indicator" v-if="user.is_online"></span>
				</div>

				<ul>
					<li>
						<h3>{{ user.name }}</h3>

						<p>Name</p>
					</li>

					<li>
						<h4 :class="{ 'not-specified': !user.country }">{{ user.age || 'Not Specified' }}</h4>

						<p>Age</p>
					</li>

					<li>
						<h4 :class="{ 'not-specified': !user.country }">{{ user.gender || 'Not Specified' }}</h4>

						<p>Gender</p>
					</li>

					<li>
						<h4 :class="{ 'not-specified': !user.country }">{{ user.country || 'Not Specified' }}</h4>

						<p>Location</p>
					</li>

					<li>
						<h4 class="message">"{{ user.profile_post || '--' }}"</h4>

						<p>Status</p>
					</li>
				</ul>
			</info-card>
		</section>

		<section>
			<emotion-card
				title="Current Emotion"
				:sticker="daily.filepath"
				:bpm="daily.heartbeat_count || 0"
				:stress="daily.stress_level"
				:mood="daily.emotion_value"
				moodDate=""
				:percent="parseInt(daily.upmood_meter) * 10"
			></emotion-card>
		</section>
	</div>
</template>

<script>
import EmotionCard from '@/components/utils/EmotionCard.vue'
import InfoCard from '@/components/layouts/InfoCard.vue'

export default {

	props: {
		user: {
			type: Object,
			required: true
		},

		daily: {
			type: Object
		}
	},

	components: {
		EmotionCard,
		InfoCard
	}
}
</script>

<style lang="scss" scoped>
.user-information {
	width: 100%;
	padding: 20px 0;
	@include flex-row;

	.avatar, ul {
		margin-right: 30px;
	}

	.avatar {
		flex-shrink: 0;
		align-self: center;
		border-radius: 50%;
		height: 150px;
		width: 150px;
		border: 1px solid $light;
		position: relative;

		.indicator {
			display: inline-block;
			background-color: $success;
			width: 25px;
			height: 25px;
			border-radius: 50%;
			position: absolute;
			top: 5px;
			right: 15px;
			box-shadow: 0 0 3px #fff;
		}
	}

	h4.not-specified {
		font-size: 12px;
		color: rgb(124, 124, 124);
	}

	section {
		flex: 1 1 auto;
		max-width: 350px;
		max-height: 450px;

		&:not(:last-child) {
			margin-right: 20px;
		}
	}
}
</style>
